import { MatterArtifactVersionStatus, type MatterArtifactVersionRead } from '@/matter-artifacts/schemas'
import type { RootState } from '@/store/store'

export function selectMatterArtifactVersionById(state: RootState, matterArtifactVersionId: string | null | undefined): MatterArtifactVersionRead | null {
  if (!matterArtifactVersionId) return null
  return state.matterArtifactsState.versionsById[matterArtifactVersionId] ?? null
}

export function selectCurrentMatterArtifactVersionByArtifactId(
  state: RootState,
  matterArtifactId: string | null | undefined
): MatterArtifactVersionRead | null {
  if (!matterArtifactId) return null

  for (const version of Object.values(state.matterArtifactsState.versionsById)) {
    if (version?.matter_artifact_id === matterArtifactId && version.status === MatterArtifactVersionStatus.COMPLETE && version.is_current) return version
  }
  return null
}

export function selectCurrentMatterArtifactVersionFromVersionId(
  state: RootState,
  matterArtifactVersionId: string | null | undefined
): MatterArtifactVersionRead | null {
  const matterArtifactVersion = selectMatterArtifactVersionById(state, matterArtifactVersionId)
  return selectCurrentMatterArtifactVersionByArtifactId(state, matterArtifactVersion?.matter_artifact_id)
}

/** Select: the artifact the open draft belongs to, which the URL names by one of its versions. */
export function selectOpenMatterArtifactId(state: RootState, props: { draftArtifactVersionId: string | null }): string | null {
  return selectMatterArtifactVersionById(state, props.draftArtifactVersionId)?.matter_artifact_id ?? null
}
